(function () {
  function setupModularSystem(root) {
if (!root || root.dataset.modsysReady === 'true') return;
    root.dataset.modsysReady = 'true';

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-modsys-reveal]'));
    var stage = root.querySelector('.modsys-boat-stage');
    var stageFrame = root.querySelector('.modsys-mobile-stage-frame');
    var cameraRig = root.querySelector('.modsys-camera-rig');
    var gatewayHub = root.querySelector('.modsys-gateway-hub');
    var sensors = Array.prototype.slice.call(root.querySelectorAll('.modsys-boat-sensor'));
    var focusTargets = gatewayHub ? [gatewayHub].concat(sensors) : sensors;
    var mobileSteps = Array.prototype.slice.call(root.querySelectorAll('[data-modsys-mobile-step]'));
    var mobileQuery = window.matchMedia('(max-width: 768px)');
    var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mobilePinFrame;
    var mobileCameraReadyFrame;
    var mobileCameraReadyFrameTwo;
    var activeMobileIndex = 0;
    var mobileStoryInitialized = false;
    var mobileSelectionLockUntil = 0;
    var mobileSelectionUnlockTimer;
    var resizeTimer;
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var mobileWorkNearby = true;

    function setResponsiveCopyState(element, hidden, focusableWhenVisible) {
      if (!element) return;
      element.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      if ('inert' in element) element.inert = hidden;
      if (hidden) element.setAttribute('tabindex', '-1');
      else if (focusableWhenVisible) element.setAttribute('tabindex', '0');
      else element.removeAttribute('tabindex');
    }

    function syncResponsiveAccessibility() {
      var isMobile = mobileQuery.matches;

      setResponsiveCopyState(gatewayHub, isMobile, !!(gatewayHub && gatewayHub.hasAttribute('data-modsys-info')));
      sensors.forEach(function(sensor) {
        setResponsiveCopyState(sensor, isMobile, sensor.hasAttribute('data-modsys-info'));
      });
      mobileSteps.forEach(function(step) {
        setResponsiveCopyState(step, !isMobile, true);
      });
    }

    function getMobileStageTop() {
      if (window.innerWidth <= 420) return 64;
      return 92;
    }

    function syncStageTop() {
      if (!stageFrame) return;
      if (!mobileQuery.matches) {
        stageFrame.style.removeProperty('--mobile-stage-top');
        return;
      }
      var nextTop = Math.round(getMobileStageTop()) + 'px';
      if (stageFrame.style.getPropertyValue('--mobile-stage-top') === nextTop) return;
      stageFrame.style.setProperty('--mobile-stage-top', nextTop);
    }

    function clampMobileCamera(value) {
      return Math.max(-56, Math.min(56, value));
    }

    function clearMobileCameraReadyFrames() {
      if (mobileCameraReadyFrame) window.cancelAnimationFrame(mobileCameraReadyFrame);
      if (mobileCameraReadyFrameTwo) window.cancelAnimationFrame(mobileCameraReadyFrameTwo);
      mobileCameraReadyFrame = null;
      mobileCameraReadyFrameTwo = null;
    }

    function armMobileCameraTransition() {
      if (root.classList.contains('is-mobile-camera-ready')) return;
      clearMobileCameraReadyFrames();
      mobileCameraReadyFrame = window.requestAnimationFrame(function() {
        mobileCameraReadyFrame = null;
        mobileCameraReadyFrameTwo = window.requestAnimationFrame(function() {
          mobileCameraReadyFrameTwo = null;
          root.classList.add('is-mobile-camera-ready');
        });
      });
    }

    function resetMobileCamera() {
      clearMobileCameraReadyFrames();
      root.classList.remove('is-mobile-camera-ready');
      if (!cameraRig) return;
      cameraRig.style.removeProperty('--mobile-camera-x');
      cameraRig.style.removeProperty('--mobile-camera-y');
      cameraRig.style.removeProperty('--mobile-camera-zoom');
    }

    function focusMobileCamera(index) {
      if (!cameraRig || !stage || !mobileQuery.matches || reduceMotionQuery.matches) {
        resetMobileCamera();
        return;
      }

      
      if (index === 0) {
        cameraRig.style.setProperty('--mobile-camera-x', '0%');
        cameraRig.style.setProperty('--mobile-camera-y', '0%');
        cameraRig.style.setProperty('--mobile-camera-zoom', '1');
        armMobileCameraTransition();
        return;
      }

      var focusTarget = focusTargets[index];
      if (!focusTarget) return;

      var sensorX = parseFloat(focusTarget.getAttribute('data-modsys-focus-x'));
      var sensorY = parseFloat(focusTarget.getAttribute('data-modsys-focus-y'));
      var focusZoom = parseFloat(window.getComputedStyle(stage).getPropertyValue('--mobile-focus-zoom'));

      if (!Number.isFinite(sensorX)) sensorX = 50;
      if (!Number.isFinite(sensorY)) sensorY = 50;
      if (!Number.isFinite(focusZoom)) focusZoom = 1.6;

      var cameraX = clampMobileCamera((50 - sensorX) * focusZoom);
      var cameraY = clampMobileCamera((50 - sensorY) * focusZoom);

      cameraRig.style.setProperty('--mobile-camera-x', cameraX.toFixed(2) + '%');
      cameraRig.style.setProperty('--mobile-camera-y', cameraY.toFixed(2) + '%');
      cameraRig.style.setProperty('--mobile-camera-zoom', focusZoom.toFixed(2));
      armMobileCameraTransition();
    }

    function syncMobileActiveStep() {
      if (!mobileSteps.length || !mobileQuery.matches) return;
      if (window.performance.now() < mobileSelectionLockUntil) return;

      var frameRect = stageFrame ? stageFrame.getBoundingClientRect() : { bottom: 0 };
      var focusY = Math.min(window.innerHeight - 120, frameRect.bottom + 42);
      var firstStepRect = mobileSteps[0].getBoundingClientRect();
      var lastStepRect = mobileSteps[mobileSteps.length - 1].getBoundingClientRect();
      var bestIndex = activeMobileIndex;
      var bestDistance = Infinity;

      if (firstStepRect.top > window.innerHeight) {
        setMobileActive(0);
        return;
      }

      if (lastStepRect.bottom < 0) {
        setMobileActive(mobileSteps.length - 1);
        return;
      }

      mobileSteps.forEach(function(step, index) {
        var rect = step.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        var center = rect.top + rect.height / 2;
        var distance = Math.abs(center - focusY);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = index;
        }
      });

      
      if (mobileStoryInitialized && bestIndex !== activeMobileIndex && mobileSteps[activeMobileIndex]) {
        var activeRect = mobileSteps[activeMobileIndex].getBoundingClientRect();
        var activeCenter = activeRect.top + activeRect.height / 2;
        var activeDistance = Math.abs(activeCenter - focusY);
        if (bestDistance + 24 >= activeDistance) bestIndex = activeMobileIndex;
      }

      setMobileActive(bestIndex);
    }

    function syncMobileStoryFrame() {
      syncStageTop();
      syncMobileActiveStep();
      syncMobileStepCoverage();
    }

    function syncMobileStepCoverage() {
      if (!mobileSteps.length || !mobileQuery.matches || !stageFrame) return;

      var frameRect = stageFrame.getBoundingClientRect();
      mobileSteps.forEach(function(step) {
        var stepRect = step.getBoundingClientRect();
        var isFullyBehindFrame = stepRect.bottom <= frameRect.bottom;
        step.classList.toggle('is-covered-by-stage', isFullyBehindFrame);
      });
    }

    function scheduleMobilePin() {
      if (!mobileQuery.matches || !mobileWorkNearby || mobilePinFrame) return;
      mobilePinFrame = window.requestAnimationFrame(function() {
        mobilePinFrame = null;
        syncMobileStoryFrame();
      });
    }

    function clearMobileStory() {
      if (gatewayHub) gatewayHub.classList.remove('is-mobile-active');
      sensors.forEach(function(sensor) { sensor.classList.remove('is-mobile-active'); });
      mobileSteps.forEach(function(step) {
        step.classList.remove('is-active');
        step.classList.remove('is-covered-by-stage');
        step.setAttribute('aria-pressed', 'false');
      });
      window.clearTimeout(mobileSelectionUnlockTimer);
      mobileSelectionLockUntil = 0;
      resetMobileCamera();
      mobileStoryInitialized = false;
    }

    function setMobileActive(index) {
      if (!mobileSteps.length || !mobileQuery.matches) return;
      var nextIndex = Math.max(0, Math.min(index, mobileSteps.length - 1));
      if (mobileStoryInitialized && nextIndex === activeMobileIndex) return;
      activeMobileIndex = nextIndex;
      mobileStoryInitialized = true;

      if (gatewayHub) gatewayHub.classList.toggle('is-mobile-active', nextIndex === 0);
      sensors.forEach(function(sensor, sensorIndex) {
        sensor.classList.toggle('is-mobile-active', sensorIndex + 1 === nextIndex);
      });

      mobileSteps.forEach(function(step, stepIndex) {
        var isActive = stepIndex === nextIndex;
        step.classList.toggle('is-active', isActive);
        step.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      focusMobileCamera(nextIndex);
    }

    function setupMobileStory() {
      syncResponsiveAccessibility();
      if (!mobileSteps.length) return;

      if (!mobileQuery.matches) {
        clearMobileStory();
        syncStageTop();
        return;
      }

      syncMobileStoryFrame();
    }

    window.addEventListener('resize', function() {
      var nextWidth = window.innerWidth || document.documentElement.clientWidth;
      var nextHeight = window.innerHeight || document.documentElement.clientHeight;
      var widthChanged = nextWidth !== viewportWidth;
      var heightDelta = Math.abs(nextHeight - viewportHeight);

      
      if (mobileQuery.matches && !widthChanged && heightDelta < 160) return;

      viewportWidth = nextWidth;
      viewportHeight = nextHeight;
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function() {
        syncMobileStoryFrame();
      }, 120);
    });
    window.addEventListener('scroll', scheduleMobilePin, { passive: true });
    if ('IntersectionObserver' in window) {
      mobileWorkNearby = false;
      var mobileWorkObserver = new IntersectionObserver(function(entries) {
        mobileWorkNearby = entries[0].isIntersecting;
        if (mobileWorkNearby) scheduleMobilePin();
      }, { rootMargin: '75% 0px' });
      mobileWorkObserver.observe(root);
    }

    mobileSteps.forEach(function(step) {
      step.addEventListener('pointerdown', function() {
        window.clearTimeout(mobileSelectionUnlockTimer);
        mobileSelectionLockUntil = 0;
      });

      step.addEventListener('click', function() {
        var stepIndex = parseInt(step.getAttribute('data-modsys-mobile-step'), 10);
        if (Number.isNaN(stepIndex)) return;
        var reduceMotion = reduceMotionQuery.matches;

        
        window.clearTimeout(mobileSelectionUnlockTimer);
        mobileSelectionLockUntil = reduceMotion ? 0 : window.performance.now() + 900;
        if (!reduceMotion) {
          mobileSelectionUnlockTimer = window.setTimeout(function() {
            mobileSelectionLockUntil = 0;
            scheduleMobilePin();
          }, 940);
        }

        setMobileActive(stepIndex);

        if (mobileQuery.matches && stageFrame) {
          var topOffset = getMobileStageTop();
          var frameRect = stageFrame.getBoundingClientRect();
          var stepRect = step.getBoundingClientRect();
          var focusY = Math.min(window.innerHeight - 120, topOffset + frameRect.height + 42);
          var targetY = window.scrollY + stepRect.top + stepRect.height / 2 - focusY;
          window.scrollTo({
            top: Math.max(0, targetY),
            behavior: reduceMotion ? 'auto' : 'smooth'
          });
        }
      });
    });

    
    var infoSensors = Array.prototype.slice.call(root.querySelectorAll('[data-modsys-info]'));
    
    var hoverQuery = window.matchMedia('(hover: hover)');

    function closeInfo(except) {
      infoSensors.forEach(function(sensor) {
        if (sensor === except) return;
        sensor.classList.remove('is-info-open');
        sensor.setAttribute('aria-expanded', 'false');
      });
    }

    function toggleInfo(sensor) {
      var willOpen = !sensor.classList.contains('is-info-open');
      closeInfo(sensor);
      sensor.classList.toggle('is-info-open', willOpen);
      sensor.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    }

    infoSensors.forEach(function(sensor) {
      sensor.addEventListener('click', function(event) {
        if (mobileQuery.matches || hoverQuery.matches) return;
        event.stopPropagation();
        toggleInfo(sensor);
      });
      sensor.addEventListener('keydown', function(event) {
        if (mobileQuery.matches || hoverQuery.matches) return;
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault();
          toggleInfo(sensor);
        }
      });
    });

    if (infoSensors.length) {
      document.addEventListener('click', function(event) {
        if (!root.contains(event.target) || !event.target.closest('[data-modsys-info]')) closeInfo(null);
      });
      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') closeInfo(null);
      });
      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', function() { closeInfo(null); });
      }
    }

    setupMobileStory();
    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', setupMobileStory);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(setupMobileStory);
    }
    if (reduceMotionQuery.addEventListener) {
      reduceMotionQuery.addEventListener('change', function() {
        if (reduceMotionQuery.matches) {
          resetMobileCamera();
        } else if (mobileQuery.matches && mobileStoryInitialized) {
          focusMobileCamera(activeMobileIndex);
        }
      });
    }

    if (!items.length) return;

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function(item) { item.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.16 });

    items.forEach(function(item) { observer.observe(item); });
  }

  function boot(scope) {
    var roots = [];
    if (scope && scope.matches && scope.matches('[data-modular-system]')) roots.push(scope);
    if (scope && scope.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-modular-system]')));
    }
    roots.forEach(setupModularSystem);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
